import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
    Drawer,
    Select,
    Modal,
} from "antd";
import { message } from "../../components/antdMessageBridge";
import { CloseCircleOutlined } from "@ant-design/icons";
import Html5QrcodePlugin from "../qrscanner/qrscanner";
import { Html5QrcodeScanType } from "html5-qrcode";
import "../manifest_verificationqueue/verification-slider.css";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import CommonObj from "../../CommonObj";
import CuttingIcon from "../../assets/img/svg/xcuttingtitleicon.svg?react";
import ScanningIcon from "../../assets/img/svg/xscanningtitleicon.svg?react";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";
import regexService, { removeSpaces } from "../../components/commonregex/regexService";

const { Option } = Select;

const selectOptions = [
    {
        value: '',
    },
    {
        value: 'Cutting',
        label: (
            <span style={{ "display": "flex","alignItems": "center"}}>
                <CuttingIcon /> Cutting
            </span>
        ),
    },
    {
        value: 'Scanning',
        label: (
            <span style={{ "display": "flex", "alignItems": "center" }}>
                <ScanningIcon /> Scanning
            </span>
        ),
    }
];

const options = [];
for (let i = 10; i < 36; i++) {
    options.push({
        value: i.toString(36) + i,
        label: i.toString(36) + i,
    });
}

const QCSliderUI = (props) => {
    const [accordionView, setaccordionView] = useState(false);
    const accordionViewChange = (e) => {
        accordionView ? setaccordionView(false) : setaccordionView(true);
    };
    const [activeScanner1, setActiveScanner1] = useState(null);
    const [form, setForm] = useState({
        bid: "",
        title: "",
        author: "",
        publisher: "",
        isbN10: "",
        isbN13: "",
        bookPageCount: "",
        language: "",
        qcErrorCategory: [],
        weight: 0.75,
        isbn: "",
        condition: "",
        qcaction: "",
        bookType: "",
        usedCondition: "",
        content: "",
        bookFormat: "",
        errcount: "",
        //  eqComplexityLevel: "",
        comments: "",
        reasonForException: "",
        formatException: "",
        rackAndShelf: "",
        rackShelf: "",
        version: "",
    });
    const [decodedResults, setDecodedResults] = useState([]);
    const { accessToken } = useAuthToken();
    const [errors, setErrors] = useState({});
    const [isMovetostationDropdownOpen, setIsMovetostationDropdownOpen] = useState(false);
    const [regexLoaded, setRegexLoaded] = useState(false);

      useEffect(() => {
        const loadRegexPatterns = async () => {
          try {
            await regexService.fetchRegexData(accessToken);
            setRegexLoaded(true);
          } catch (error) {
            console.error("Failed to load regex patterns:", error);
          }
        };
        
        if (accessToken) {
          loadRegexPatterns();
        }
      }, [accessToken]);
    useEffect(() => {
        delete form?.rackAndShelf
        setForm((prev) => ({ ...prev, rackAndShelf: props?.formdata?.NrackAndShelf }))
    }, [props?.formdata?.NrackAndShelf]);
    const validate = () => {
        const newErrors = {};
        const rackAndShelfValue = (form?.rackAndShelf || "").trim();
        const normalizedRackAndShelf = removeSpaces(rackAndShelfValue).toLowerCase();
        const normalizedCurrentRackShelf = removeSpaces(props?.formdata?.rackShelf || "").toLowerCase();

        if (!form.qcErrorCategory || form.qcErrorCategory.length === 0) {
            newErrors.qcErrorCategory = "Please select the error category";
        }
        if (!form.errcount || !form.errcount.trim()) {
            newErrors.errcount = "Please enter the error number";
        }
        if (
            (form.qcaction === "Rework" && !form.qcMoveToNextStation)
        ) {
            newErrors.qcMoveToNextStation = "Move to Station is required";
        }
        if (!form.qcaction || !form.qcaction.trim()) {
            newErrors.qcaction = "QA action is required";
        }
        if (form.qcaction === "Rework" && !rackAndShelfValue) {
            newErrors.rackAndShelf = "Rack and Shelf is required";
        }
        else if ((form.qcaction === "Self fixed" || form.qcaction === "Rework") && normalizedRackAndShelf && normalizedRackAndShelf === normalizedCurrentRackShelf) {
            newErrors.rackAndShelf =
                "Books sent for rework cannot be placed in the same rack. Please scan the new rack"
        }
        else if (regexLoaded && rackAndShelfValue) {
            const validation = regexService.validateRackShelf(rackAndShelfValue);
            if (!validation.isValid) {
                newErrors.rackAndShelf = "Input format invalid: No matching pattern found.";
            }
        }


        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const [isDisabled, setIsDisabled] = useState(false);

const handleSubmit = async (e) => {
  e.preventDefault();
  
  setIsDisabled(true);
  disableButtonTemporarily();

  if (!await handleValidation()) return;
  
  await submitQCProcess();
};

const disableButtonTemporarily = () => {
  setTimeout(() => setIsDisabled(false), 3000);
};

const handleValidation = async () => {
  if (!validate()) {
    await focusFirstError();
    return false;
  }
  message.destroy();
  return true;
};

const focusFirstError = async () => {
  console.log("Validation Failed:", errors);
  const firstErrorField = Object.keys(errors)[0];
  if (firstErrorField) {
    const element = document.getElementById(firstErrorField);
    if (element) element.focus();
  }
};

const submitQCProcess = async () => {
  try {
    const submissionData = buildSubmissionData();
    const response = await makeQCSubmitRequest(submissionData);
    
    await handleSuccessResponse(response);
  } catch (error) {
    handleError(error);
  }
};

const buildSubmissionData = () => {
  const baseData = {
    bid: props?.bid,
    updatedPageCount: props?.updatedPagecnt,
    isSelfFixed: form.qcaction === "Self fixed",
    userId: props?.created,
    rackShelf: getRackShelfValue(),
    errorCategoryIds: getErrorCategoryIds(),
    errorCount: form?.errcount,
    errorCommand: form?.comments,
    qcStatus: form.qcaction === "Self fixed" ? 1 : 2,
    moveToNextStation: form?.qcMoveToNextStation,
    bidScanTime: props?.formdata?.bidScanTime || "",
  };
  
  return baseData;
};

const getRackShelfValue = () => {
  return (form?.rackAndShelf != undefined && form?.rackAndShelf != "") 
    ? form.rackAndShelf.trim() 
    : (props?.formdata?.rackAndShelf != "" && props?.formdata?.rackAndShelf != 1 
      ? props.formdata.rackAndShelf.trim() 
      : props.formdata.rackShelf.trim());
};

const getErrorCategoryIds = () => {
  return Array.isArray(form?.qcErrorCategory)
    ? form.qcErrorCategory.join(",")
    : form?.qcErrorCategory;
};

const getUsedCondition = () => {
  return props?.formdata.usedCondition == '' || props?.formdata.usedCondition == null 
    ? '0' 
    : props.formdata.usedCondition;
};

const getContentValue = () => {
  return Array.isArray(props?.formdata.content)
    ? props.formdata.content.join(",")
    : props.formdata.content;
};

const makeQCSubmitRequest = async (submissionData) => {
  const response = await fetch(CommonObj.Endpoints.QCSubmitQCProcess, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "X-CSRF-Token": encryptTimestamp(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(submissionData),
  });

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }
  
  return response;
};

const handleSuccessResponse = async (res) => {
  const successMessage = form.qcaction === "Self fixed"
    ? "QC Completed successfully. Books are ready for Delivery"
    : "QC Rework successfully.";
    
  message.success(successMessage);
  resetForm();
  props.onClose();
  props?.clearForm();
};

const resetForm = () => {
  setForm({
    bid: "", title: "", author: "", publisher: "",
    isbN10: "", isbN13: "", bookPageCount: "", language: "",
    qcErrorCategory: "", weight: 0.75, isbn: "", condition: "",
    qcaction: "", bookType: "", usedCondition: "", content: "",
    bookFormat: "", errcount: "", comments: "", reasonForException: "",
    formatException: "", rackAndShelf: "1", rackShelf: "", version: "",
    qcmoveToNextStation: "",
  });
  setErrors({});
};

const handleError = (error) => {
  message.error("Error submitting form: " + error.message, 5);
};
    const onNewScanResult = (decodedText, decodedResult) => {
        setDecodedResults((prev) => [...prev, decodedResult]);
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "rackAndShelf") {
            delete props?.formdata?.NrackAndShelf
        }
        setForm((prev) => {
            const updatedForm = { ...prev, [name]: value };

            return updatedForm;
        });
        if (errors[name]) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
        if (name === "qcaction" && value != "Rework") {
            delete errors.rackAndShelf;
            return errors;
        }
    };
    const handleMoveTostationChange = (e) => {
        setForm((prev) => ({ ...prev, qcMoveToNextStation: e }))

        if (errors['qcMoveToNextStation']) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors['qcMoveToNextStation'];
                return newErrors;
            });
        }
    };

    const handleNumericKeyDown = (event) => {
        if (['e', 'E', '+', '-'].includes(event.key)) {
            event.preventDefault();
        }
    };
const handleAntdChange = (values, fieldName) => {
    setForm((prevForm) => ({
        ...prevForm,
        [fieldName]: values,
    }));

    if (errors[fieldName]) {
        const hasValue = Array.isArray(values) ? values.length > 0 : !!values;
        if (hasValue) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[fieldName];
                return newErrors;
            });
        }
    }
};
    return (
        <>
            <Modal
                title={`Scan ${activeScanner1 ? activeScanner1 : ""}`}
                open={!!activeScanner1}
                onCancel={() => setActiveScanner1(null)}
                footer={null}
                destroyOnClose
                className="scan-model-container"
            >
                <div className="scan-modal">
                    <Html5QrcodePlugin
                        fps={20}
                        qrbox={500}
                        disableFlip={false}
                        qrCodeSuccessCallback={onNewScanResult}
                        supportedScanTypes={[Html5QrcodeScanType.SCAN_TYPE_CAMERA]}
                    />
                </div>
            </Modal>
            <Drawer
                title={props.title}
                placement={props.placement}
                onClose={props.onClose}
                open={props.visible}
                width={props.width}
                className={props.className}
                closeIcon={<CloseCircleOutlined />}
            >
                <div className="qc-failure-container">
                    <div
                        className={`${"delivery-rules-container"} ${accordionView ? "active" : ""
                            }`}
                    >
                        <div className="delivery-rules-title">
                            <h5>
                                <span>
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M15.152 6.69912L15.5382 6.31292C16.1781 5.67304 17.2155 5.67304 17.8554 6.31292C18.4953 6.95279 18.4953 7.99024 17.8554 8.63011L17.4692 9.01631M15.152 6.69912C15.152 6.69912 15.2003 7.51979 15.9244 8.24391C16.6485 8.96804 17.4692 9.01631 17.4692 9.01631M15.152 6.69912L11.6015 10.2496C11.361 10.4901 11.2407 10.6104 11.1373 10.7429C11.0153 10.8993 10.9108 11.0686 10.8254 11.2476C10.7531 11.3994 10.6993 11.5607 10.5918 11.8833L10.2474 12.9163L10.136 13.2505M17.4692 9.01631L13.9187 12.5668C13.6782 12.8073 13.5579 12.9276 13.4254 13.031C13.269 13.153 13.0997 13.2575 12.9207 13.3429C12.7689 13.4152 12.6076 13.469 12.2849 13.5765L11.252 13.9209L10.9178 14.0323M10.9178 14.0323L10.5836 14.1437C10.4248 14.1966 10.2497 14.1553 10.1314 14.0369C10.013 13.9186 9.97171 13.7435 10.0246 13.5847L10.136 13.2505M10.9178 14.0323L10.136 13.2505"
                                            stroke="#002449"
                                            strokeWidth="1.25558"
                                        />
                                        <path
                                            d="M6.66895 10.833H8.75228"
                                            stroke="#002449"
                                            strokeWidth="1.25558"
                                            strokeLinecap="round"
                                        />
                                        <path
                                            d="M6.66895 7.5H12.0856"
                                            stroke="#002449"
                                            strokeWidth="1.25558"
                                            strokeLinecap="round"
                                        />
                                        <path
                                            d="M6.66895 14.167H7.91895"
                                            stroke="#002449"
                                            strokeWidth="1.25558"
                                            strokeLinecap="round"
                                        />
                                        <path
                                            opacity="0.5"
                                            d="M2.50195 8.33366C2.50195 5.19096 2.50195 3.61961 3.47826 2.6433C4.45457 1.66699 6.02592 1.66699 9.16862 1.66699H10.8353C13.978 1.66699 15.5493 1.66699 16.5256 2.6433C17.502 3.61961 17.502 5.19096 17.502 8.33366V11.667C17.502 14.8097 17.502 16.381 16.5256 17.3573C15.5493 18.3337 13.978 18.3337 10.8353 18.3337H9.16862C6.02592 18.3337 4.45457 18.3337 3.47826 17.3573C2.50195 16.381 2.50195 14.8097 2.50195 11.667V8.33366Z"
                                            stroke="#002449"
                                            strokeWidth="1.25558"
                                        />
                                    </svg></span>Delivery Rules Integration
                            </h5>

                            <button
                                className="delivery-rules-expand-button"
                                onClick={accordionViewChange}
                            >
                                {!accordionView ? (
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect
                                            x="-0.00195312"
                                            width="24"
                                            height="24"
                                            rx="12"
                                            fill="#F1FBFF"
                                        />
                                        <g clipPath="url(#clip0_2792_34959)">
                                            <path
                                                d="M19.998 12C19.998 13.0506 19.7911 14.0909 19.3891 15.0615C18.987 16.0321 18.3978 16.914 17.6549 17.6569C16.912 18.3997 16.0301 18.989 15.0595 19.391C14.0889 19.7931 13.0486 20 11.998 20C10.9475 20 9.90718 19.7931 8.93658 19.391C7.96597 18.989 7.08406 18.3997 6.34119 17.6569C5.59832 16.914 5.00905 16.0321 4.60701 15.0615C4.20497 14.0909 3.99805 13.0506 3.99805 12C3.99805 9.87827 4.8409 7.84344 6.34119 6.34315C7.84148 4.84285 9.87631 4 11.998 4C14.1198 4 16.1546 4.84285 17.6549 6.34315C19.1552 7.84344 19.998 9.87827 19.998 12Z"
                                                stroke="#009DDB"
                                                strokeWidth="1.2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M14.998 12H8.99805"
                                                stroke="#0009E2"
                                                strokeWidth="1.2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_2792_34959">
                                                <rect
                                                    width="18"
                                                    height="18"
                                                    fill="white"
                                                    transform="translate(2.99805 3)"
                                                />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                ) : (
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g clipPath="url(#clip0_2792_34989)">
                                            <path
                                                opacity="0.5"
                                                d="M19.998 12C19.998 13.0506 19.7911 14.0909 19.3891 15.0615C18.987 16.0321 18.3978 16.914 17.6549 17.6569C16.912 18.3997 16.0301 18.989 15.0595 19.391C14.0889 19.7931 13.0486 20 11.998 20C10.9475 20 9.90718 19.7931 8.93658 19.391C7.96597 18.989 7.08406 18.3997 6.34119 17.6569C5.59832 16.914 5.00905 16.0321 4.60701 15.0615C4.20497 14.0909 3.99805 13.0506 3.99805 12C3.99805 9.87827 4.8409 7.84344 6.34119 6.34315C7.84148 4.84285 9.87631 4 11.998 4C14.1198 4 16.1546 4.84285 17.6549 6.34315C19.1552 7.84344 19.998 9.87827 19.998 12Z"
                                                stroke="#002449"
                                                strokeWidth="1.2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M11.9967 9.33301V14.6663M14.6634 11.9997H9.33008"
                                                stroke="#002449"
                                                strokeWidth="1.2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_2792_34989">
                                                <rect
                                                    width="18"
                                                    height="18"
                                                    fill="white"
                                                    transform="translate(2.99805 3)"
                                                />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                )}
                            </button>
                        </div>
                        {!accordionView ? (
                            <div className="delivery-rules-content">
                                <p>
                                    Failed QC items will be automatically flagged and excluded
                                    from delivery workflows until issues are resolved. The system
                                    will track QC failures and generate reports for quality
                                    improvement.
                                </p>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>

                    <form
                        className="qc-failure-form-container"
                        onSubmit={handleSubmit}
                        noValidate
                    >
                        <div className="field-group qc-dropdown">
                            <Select
                                mode="multiple"
                                name="qcErrorCategory"
                                id="qcErrorCategory"
                                style={{ width: '100%'}}
                                className={`book-page-form-input-text ${form?.qcErrorCategory?.length ? "has-text" : ""}`}
                                value={form?.qcErrorCategory || []}
                                onChange={(values) => handleAntdChange(values, 'qcErrorCategory')}
                                filterOption={(input, option) =>
                                    (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {props?.datasource?.qcErrorCategory?.map((item) => (
                                    <Option
                                        key={item?.errorCategoryId}
                                        value={item?.errorCategoryId}
                                        label={item?.category} 
                                    >
                                        {item?.category}
                                    </Option>
                                ))}
                            </Select>

                            <label htmlFor="qcErrorCategory">
                                Error Category <span className="form-required">*</span>
                            </label>
                            {errors.qcErrorCategory && (
                                <span className="error-msg">{errors.qcErrorCategory}</span>
                            )}
                        </div>
                        <div className="field-group">
                            <input
                                id="errcount"
                                name="errcount"
                                type="number"
                                min="0"
                                className={`${"book-page-form-input-text"} ${form.errcount === "" ? "" : "has-text"
                                    }`}
                                value={form?.errcount}
                                onChange={handleChange}
                                onKeyDown={handleNumericKeyDown}
                            />

                            <label htmlFor="errcount">
                                Error Count <span className="form-required">*</span>
                            </label>
                            {errors.errcount && (
                                <span className="error-msg">{errors.errcount}</span>
                            )}
                        </div>
                        <div className="qc-action-radio-container">
                            <p className="qc-action-radio-title">
                                QC Action <span className="form-required">*</span>
                            </p>

                            <div className="qc-action-radio-button">
                                <input
                                    type="radio"
                                    name="qcaction"
                                    id="qc-action-radio-self-fixed"
                                    value="Self fixed"
                                    onChange={handleChange}
                                />
                                <label htmlFor="qc-action-radio-self-fixed">Self fixed</label>
                            </div>
                            <div className="qc-action-radio-button">
                                <input
                                    type="radio"
                                    name="qcaction"
                                    id="qc-action-radio-rework"
                                    value="Rework"
                                    onChange={handleChange}
                                />
                                <label htmlFor="qc-action-radio-rework">Rework</label>
                            </div>
                            {errors.qcaction && (
                                <span className="error-msg">{errors.qcaction}</span>
                            )}
                        </div>
                        {form.qcaction == "Rework" && (
                            <div className="field-group select-container no-ring">
                                <Select
                                    id="qcMoveToNextStation"
                                    className={`${"book-page-form-input-text"} ${form?.qcMoveToNextStation ? "has-text" : ""}`}
                                    name="qcMoveToNextStation"
                                    defaultValue={form?.qcMoveToNextStation}
                                    style={{ width: 200 }}
                                    options={selectOptions}
                                    onChange={handleMoveTostationChange}
                                />
                                <label htmlFor="qcMoveToNextStation">
                                    Move to Station<span className="form-required">*</span>
                                </label>
                                {errors.qcMoveToNextStation && (
                                    <span className="error-msg">{errors.qcMoveToNextStation}</span>
                                )}
                            </div>
                        )}
                        <div className="field-group span2column margin-top-20">
                            <textarea
                                id="comments"
                                rows="3"
                                placeholder="Describe the specific issues found during QC"
                                value={form.comments}
                                onChange={(e) =>
                                    setForm((prev) => ({ ...prev, comments: e.target.value }))
                                }
                                className={`${"book-page-form-input-textarea"} ${form.content === "" ? "" : "has-text"
                                    }`}
                            ></textarea>

                            <label htmlFor="comments" className="comment-input-label-indent">
                                Error Comments
                            </label>
                        </div>
                        <div className="book-page-form-scan-rack-container  bgColor span2column">
                            <span className={`${form.qcaction === "Rework" ? "form-required-rack" : "hide"
                                }`} >*</span>
                            <input
                                className="book-page-form-scan-rack-button"
                                id="rackAndShelf"
                                name="rackAndShelf"
                                placeholder="Enter / Scan Rack Shelf Barcode"
                                // className={`${"book-page-form-input-text"} ${
                                //   form.rackAndShelf === "" ? "" : "has-text"
                                // }`}
                                value={form.rackAndShelf != "" ? form.rackAndShelf : props?.formdata?.NrackAndShelf}
                                onChange={handleChange}
                                required
                            ></input>

                            <button
                                className="book-page-form-scan-rack-button-icon"
                                data-track="qc-slide-open-rack-scanner"
                                onClick={() => { props.emptyDecode(); props.onScannerOpen("New Rack & Shelf ID") }}
                            >
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="12"
                                        cy="13"
                                        r="3"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M10.0001 20H14.0001C16.809 20 18.2135 20 19.2224 19.3259C19.6591 19.0341 20.0341 18.6591 20.326 18.2223C21.0001 17.2134 21.0001 15.8089 21.0001 13C21.0001 10.1911 21 8.78685 20.3258 7.77795C20.034 7.34119 19.659 6.96619 19.2222 6.67436C18.2133 6.00023 16.8089 6.00023 14 6.00023H9.99995C7.19103 6.00023 5.78656 6.00023 4.77767 6.67436C4.34091 6.96619 3.96591 7.34119 3.67407 7.77795C3.0001 8.78663 3.0001 10.1905 3.0001 12.9982L3.0001 13C3.0001 15.8089 3.0001 17.2134 3.67422 18.2223C3.96605 18.6591 4.34106 19.0341 4.77782 19.3259C5.78671 20 7.19117 20 10.0001 20Z"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        d="M18 10H17.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M14.5 3.5H9.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                </svg>
                                <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M6.00098 1C6.00098 0.447715 6.41425 0 6.92405 0H13.0779C13.5877 0 14.001 0.447715 14.001 1C14.001 1.55228 13.5877 2 13.0779 2H6.92405C6.41425 2 6.00098 1.55228 6.00098 1Z" fill="url(#paint0_linear_2146_40101)" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M7.77875 18H12.2232C15.3442 18 16.9047 18 18.0257 17.2777C18.511 16.965 18.9277 16.5632 19.252 16.0953C20.001 15.0143 20.001 13.5095 20.001 10.4999C20.001 7.49027 20.0008 5.9857 19.2518 4.90473C18.9275 4.43676 18.5109 4.03497 18.0256 3.72228C16.9046 3 15.3441 3 12.223 3H7.77859C4.65756 3 3.09705 3 1.97605 3.72228C1.49077 4.03497 1.0741 4.43676 0.749835 4.90473C0.000976503 5.98547 0.000976526 7.48961 0.000976563 10.4979L0.000976563 10.4999C0.000976563 13.5095 0.000976622 15.0143 0.750001 16.0953C1.07426 16.5632 1.49093 16.965 1.97622 17.2777C3.09721 18 4.65773 18 7.77875 18ZM5.83431 10.4999C5.83431 8.28085 7.69979 6.48196 10.001 6.48196C12.3022 6.48196 14.1676 8.28085 14.1676 10.4999C14.1676 12.7189 12.3022 14.5178 10.001 14.5178C7.69979 14.5178 5.83431 12.7189 5.83431 10.4999ZM7.50098 10.4999C7.50098 9.16846 8.62027 8.08913 10.001 8.08913C11.3817 8.08913 12.501 9.16846 12.501 10.4999C12.501 11.8313 11.3817 12.9106 10.001 12.9106C8.62027 12.9106 7.50098 11.8313 7.50098 10.4999ZM16.1121 6.48196C15.6519 6.48196 15.2788 6.84174 15.2788 7.28554C15.2788 7.72935 15.6519 8.08913 16.1121 8.08913H16.6676C17.1279 8.08913 17.501 7.72935 17.501 7.28554C17.501 6.84174 17.1279 6.48196 16.6676 6.48196H16.1121Z" fill="url(#paint1_linear_2146_40101)" />
                                    <defs>
                                        <linearGradient id="paint0_linear_2146_40101" x1="20.601" y1="8.95028" x2="-0.0170404" y2="11.3301" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                        <linearGradient id="paint1_linear_2146_40101" x1="20.601" y1="8.95028" x2="-0.0170404" y2="11.3301" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </button>
                            <span className="error-msg-rad">{errors.rackAndShelf}</span>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="modal-cancel-button"
                                onClick={() => {
                                    setForm({
                                        bid: "",
                                        title: "",
                                        author: "",
                                        publisher: "",
                                        isbN10: "",
                                        isbN13: "",
                                        bookPageCount: "",
                                        language: "",
                                        qcErrorCategory: "",
                                        weight: 0.75,
                                        isbn: "",
                                        condition: "",
                                        qcaction: "",
                                        bookType: "",
                                        usedCondition: "",
                                        content: "",
                                        bookFormat: "",
                                        errcount: "",
                                        comments: "",
                                        reasonForException: "",
                                        formatException: "",
                                        rackAndShelf: "1",
                                        rackShelf: "",
                                        version: "",
                                        qcmoveToNextStation: ""
                                    });
                                    props.onClose();
                                }}
                            >
                                Cancel
                            </button>
                            <button className="qc-failure-submit-button" disabled={isDisabled}>
                                {" "}
                                {form.qcaction == "Rework" ? "Rework" : "Submit"}
                            </button>
                        </div>
                    </form>
                </div>
            </Drawer>
        </>
    );
};

QCSliderUI.propTypes = {
    bid: PropTypes.any,
    updatedPagecnt: PropTypes.any,
    created: PropTypes.any,
    onClose: PropTypes.func,
    clearForm: PropTypes.func,
    title: PropTypes.string,
    placement: PropTypes.string,
    visible: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    emptyDecode: PropTypes.func,
    onScannerOpen: PropTypes.func,
    datasource: PropTypes.shape({
        qcErrorCategory: PropTypes.array,
    }),
    formdata: PropTypes.shape({
        NrackAndShelf: PropTypes.any,
        rackShelf: PropTypes.any,
        rackAndShelf: PropTypes.any,
        isbn: PropTypes.any,
        title: PropTypes.any,
        author: PropTypes.any,
        publisher: PropTypes.any,
        isbN10: PropTypes.any,
        isbN13: PropTypes.any,
        bookPageCount: PropTypes.any,
        language: PropTypes.any,
        weight: PropTypes.any,
        bookFormat: PropTypes.any,
        condition: PropTypes.any,
        usedCondition: PropTypes.any,
        content: PropTypes.any,
        eqComplexityLevel: PropTypes.any,
        formatException: PropTypes.any,
        bookType: PropTypes.any,
    }),
};

export default QCSliderUI;
